import { gql } from '@apollo/client';

const OAR_FRAGMENT = gql`
  fragment OrganAtRisk on RoOrganAtRiskType {
    organ
    maxValue
    maxValueUnit
    meanValue
    meanValueUnit
    alara
    prioritized
    volumeConstraintData {
      firstValue
      firstValueUnit
      secondValue
      secondValueUnit
      operator
    }
    dConstraintData {
      dosetoPrefixOperator
      firstValue
      firstValueUnit
      secondValue
      secondValueUnit
      operator
    }
  }
`;

export const VOLUMING_OAR_QUERY = gql`
  ${OAR_FRAGMENT}
  query roOrganAtRisk($prescriptionId: ID!) {
    roOrganAtRisk(prescriptionId: $prescriptionId) {
      ...OrganAtRisk
    }
  }
`;

export const OAR_TEMPLATE_QUERY = gql`
  ${OAR_FRAGMENT}
  query templateOrganAtRisk($templateId: ID!) {
    templateOrganAtRisk(templateId: $templateId) {
      ...OrganAtRisk
    }
  }
`;

export const GET_ORGAN_LIST = gql`
  query organList {
    oarOrganList {
      id
      organ
    }
  }
`;

export const ORGAN_AT_RISK_TEMPLATE_VALUE_VARIATION = gql`
  ${OAR_FRAGMENT}
  query organAtRiskTemplateValuesVariation($prescriptionId: ID!) {
    organAtRiskTemplateValuesVariation(prescriptionId: $prescriptionId) {
      ...OrganAtRisk
    }
  }
`;

export const DELETE_OAR = gql`
  mutation roDeleteOrganAtRisk($prescriptionId: ID!, $index: ID!) {
    roDeleteOrganAtRisk(prescriptionId: $prescriptionId, index: $index) {
      ok
    }
  }
`;

export const OAR_QUERY = gql`
  ${OAR_FRAGMENT}
  query roOrganAtRisk($prescriptionId: ID!) {
    roOrganAtRisk(prescriptionId: $prescriptionId) {
      ...OrganAtRisk
    }
  }
`;

export const RESET_OAR = gql`
  mutation roResetOrganAtRisk($prescriptionId: ID!, $organ: String!) {
    roResetOrganAtRisk(prescriptionId: $prescriptionId, organ: $organ) {
      success
    }
  }
`;

export const REORDER_OAR = gql`
  mutation roReorderOrganAtRisk(
    $prescriptionId: ID!
    $sourcePrioritized: Boolean!
    $sourceIndex: Int!
    $destinationPrioritized: Boolean!
    $destinationIndex: Int!
  ) {
    roReorderOrganAtRisk(
      prescriptionId: $prescriptionId
      sourcePrioritized: $sourcePrioritized
      destinationPrioritized: $destinationPrioritized
      sourceIndex: $sourceIndex
      destinationIndex: $destinationIndex
    ) {
      ok
    }
  }
`;

export const ADD_OAR = gql`
  ${OAR_FRAGMENT}
  mutation roCreateOrganAtRisk(
    $prescriptionId: ID!
    $alara: Boolean
    $organ: String
    $volumeConstraintData: [RoOrganAtRiskConstraintInputType]
    $dConstraintData: [RoOrganAtRiskConstraintInputType]
    $maxValue: [Float]
    $maxValueUnit: String
    $meanValue: [Float]
    $meanValueUnit: String
  ) {
    roCreateOrganAtRisk(
      prescriptionId: $prescriptionId
      alara: $alara
      organ: $organ
      maxValue: $maxValue
      maxValueUnit: $maxValueUnit
      meanValue: $meanValue
      meanValueUnit: $meanValueUnit
      volumeConstraintData: $volumeConstraintData
      dConstraintData: $dConstraintData
    ) {
      organAtRisk {
        prescriptionId
        ...OrganAtRisk
      }
    }
  }
`;

export const UPDATE_OAR = gql`
  ${OAR_FRAGMENT}
  mutation roUpdateOrganAtRisk(
    $prescriptionId: ID!
    $index: ID!
    $alara: Boolean
    $organ: String
    $volumeConstraintData: [RoOrganAtRiskConstraintInputType]
    $dConstraintData: [RoOrganAtRiskConstraintInputType]
    $maxValue: [Float]
    $maxValueUnit: String
    $meanValue: [Float]
    $meanValueUnit: String
  ) {
    roUpdateOrganAtRisk(
      prescriptionId: $prescriptionId
      index: $index
      alara: $alara
      organ: $organ
      maxValue: $maxValue
      maxValueUnit: $maxValueUnit
      meanValue: $meanValue
      meanValueUnit: $meanValueUnit
      volumeConstraintData: $volumeConstraintData
      dConstraintData: $dConstraintData
    ) {
      organAtRisk {
        prescriptionId
        ...OrganAtRisk
      }
    }
  }
`;
